export default __webpack_public_path__ + "static/media/gallery_03.60138463.jpg";